import React, { FC, PropsWithChildren, ReactNode, useState } from 'react'

import { Close } from '@radix-ui/react-dialog'

import { PendingEventHandler } from 'core/components/lib/Button/Button'
import Clickable from 'core/components/lib/Clickable'
import Dialog, { DialogActions, DialogText } from 'core/components/lib/Dialog/Dialog'

type ConfirmDialogProps = PropsWithChildren<{
  title: string
  content?: ReactNode
  onConfirm: PendingEventHandler<React.MouseEvent<HTMLButtonElement, MouseEvent>>
  isOpen?: boolean
  onOpenChange?: (value: boolean) => void
}>

const ConfirmDialog: FC<ConfirmDialogProps> = ({ children, title, content, onConfirm, isOpen, onOpenChange }) => {
  const [isOpenLocal, setOpenLocal] = useState(false)

  return (
    <Dialog
      content={
        <>
          {!!content && <DialogText>{content}</DialogText>}
          <DialogActions>
            <Close asChild>
              <Clickable variant='ghost'>No</Clickable>
            </Close>
            <Clickable
              onClick={async (e) => {
                await onConfirm(e)

                if (onOpenChange) {
                  onOpenChange(false)
                } else {
                  setOpenLocal(false)
                }
              }}
              variant='secondary'
            >
              Yes
            </Clickable>
          </DialogActions>
        </>
      }
      isOpen={isOpen || isOpenLocal}
      onOpenChange={onOpenChange ?? setOpenLocal}
      title={title}
    >
      {children}
    </Dialog>
  )
}

export default ConfirmDialog
